import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/919835040629"
      className="whatsapp-float group fixed bottom-[30px] right-[30px] z-[999] w-[60px] h-[60px] rounded-full bg-whatsapp flex items-center justify-center shadow-[0_4px_15px_rgba(37,211,102,0.4)] transition-all duration-300 animate-whatsapp-pulse hover:scale-110 hover:shadow-[0_6px_25px_rgba(37,211,102,0.6)] hover:animate-none md:bottom-[30px] md:right-[30px] max-md:bottom-5 max-md:right-5 max-md:w-[55px] max-md:h-[55px]"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="text-[2rem] text-white max-md:text-[1.8rem]" />
      <span className="whatsapp-tooltip absolute right-[70px] bg-white text-gray-700 text-xs font-semibold py-2 px-3.5 rounded-lg whitespace-nowrap shadow-md opacity-0 pointer-events-none transition-opacity duration-300 group-hover:opacity-100 max-md:hidden">Chat with us</span>
    </a>
  );
};

export default WhatsAppFloat;
